import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi} from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import ModalHierarchySWOT from "src/components/ModalHierarchySwotItens";
import { standardErrorMessages } from "src/utils/errors";
import { IRefModalSWOTBounds } from "../interface";

const ModalSWOTBounds: React.ForwardRefRenderFunction<IRefModalSWOTBounds> = (_, ref) => {
	const { translate } = useTranslation(); 
	const { addToast } = RCCHookToast();
	const modalActionsHierarchySWOT = useRef<RCCRefModalProps>(null);
	
	const [swotId,setSwotId] = useState<number>();
	const [swotItemId,setSwotItemId] = useState<number>();
	const [initalData,setInitalData] = useState<Array<number>>();

	const onSubmit = async (data: any) => {
		
		try {
			await RCCServicesApi.postRequest({
				method: "SWOT/InsertSWOTBonds",
				body: {
					ids:data,
					mes002Id:swotItemId
				}
			});	

			addToast({
				color: "green",
				description: translate("Vinculos alterados com sucesso" ),
				title: translate("Sucesso")
			});

			modalActionsHierarchySWOT.current?.closeModal();
		} catch (error) {
			standardErrorMessages(error, translate("Erro ao vincular itens SWOT"), addToast);
		}

	};

	const requestSWOTBonds = async (mes002Id:any ) => {
		try {
			const {data} = await RCCServicesApi.getRequest({
				method: "SWOT/SelectSWOTItem",
				urlParameters: {
					mes002Id	
				}
			});	
			setInitalData(data.bonds.map((x:any) => x.mes002Id));

		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar vinculos com itens SWOT"), addToast);
		}
	};

	const openModalActionsHierarchySWOT = async (SwotId:number,itemId:number) => {
		setSwotItemId(itemId);
		setSwotId(SwotId);
		await requestSWOTBonds(itemId);
		modalActionsHierarchySWOT.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
		openModalActionsHierarchySWOT
	}));

	return (
		<ModalHierarchySWOT 
			ref={modalActionsHierarchySWOT}
			onSubmit={onSubmit}
			title="Selecione os Itens da SWOT para associar"
			selectOptions="multi"
			initialData={initalData}
			SWOTId={swotId||0}
			SWOTItemId={swotItemId}
		/>
	);
};

export default React.forwardRef(ModalSWOTBounds);
